module.exports = __webpack_public_path__ + "img/sn_ico.a6de384d.png";